/*
導入手順
* emarf3,emarf4共通
CloudWatchLogsに書き込み権限のあるIAMユーザーを作成し、AppKey,AppSecを保存しておく。

* gh_webgl_interpreter への導入
・必要な設定
/src/plugin.js に、ログ取り用IAMユーザーのappkey,appsecと、ログを書き込むリージョン、ロググループ、ログストリームを設定する
例:
Vue.use(Emarf, {
	emarfEnv: process.env.EMARF_ENV,
	cloudwatch: {
		appkey: 'AKIAWOQM3DYAO5ZPA2BV', // CloudWatchLogに書き込むIAMユーザーのAPPキー
		appsec: 'FfFhKjUJpCtn3trTNGnZMnrMSB1fj3Z+QUVdWLfO', // CloudWatchLogに書き込むIAMユーザーのAPPシークレット
		region: 'ap-northeast-1', // CloudWatchLogのリージョン
		loggroup: '/app/userlogs/emarf4', // CloudWatchLogのロググループ
		logstream: 'emarf4-user-logs',  // CloudWatchLogのログストリーム
	},
});

・ログを投げる
ログを採りたい箇所で

import { cwLogger } from '../cwLogger.js';

cwLogger(this.$emarf.cwConfig,"log message");

等とする。
投げられたログは、指定のロググループ>ログストリームに
"user.sub":"log message"
という形式で記録される。
ロググループ,ログストリームが存在しないと失敗する。

*/

import { CloudWatchLogs } from 'aws-sdk';
import { Auth } from 'aws-amplify';

function string2logEvent(message)
{
  return {
    message: message,
    timestamp: new Date().getTime(),
  };
}

export async function cwLogger(config,log)
{
  const currentUser = await Auth.currentAuthenticatedUser();
  var userid = "*";
  if( currentUser && currentUser["username"] ){
    userid = currentUser["username"];
  }
  if( !config['appkey'] || !config['appsec'] || !config['region'] || !config['loggroup'] || !config['logstream'] ){
    console.error('cwLogger-config-error');
    return;
  }

  const cred = {
    accessKeyId: config.appkey,
    secretAccessKey: config.appsec,
    region: config.region,
    apiVersion: "latest",
  };
  const cwloggerInstance = new CloudWatchLogs(cred);
  const result = cwloggerInstance.putLogEvents({
    logGroupName: config.loggroup,
    logStreamName: config.logstream,
    logEvents: [string2logEvent(userid+":"+log)]
  },
  (err, data) => {
    if (err) {
//      console.log('cwLogger-error');
      console.error(err, err.stack);
    } else {
//      console.log('cwLogger-done',data);
    }
  });
//  console.log('cwLogger-called:',result,log);
}


// WEBPACK FOOTER //
// ./src/cwLogger.js